//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "FarmingOrderSettleList",
  data() {
    return {
      filterForm: {
        trustee: "",
        orderType: "",
        crop: "",
        workType: "",
        statusFlag: "",
      },
      cropData: [],
      workTypeData: [],
      status: [
        { id: 5, name: "待确认" },
        { id: 10, name: "已确认" },
        { id: 15, name: "执行中" },
        { id: 20, name: "已结束" },
      ],
      pagination: {
        currentPage: 1,
        pageSize:10,
        recordTotal: 0,
      },
      allFilters: {},
      orders: [],
      masterId: "",
    };
  },
  filters: {
    formatDate(value) {
      if (!value) return;
      let result = "";
      let ary = value.split("-");
      result = `${ary[0]}年${ary[1]}月${ary[2]}日`;
      return result;
    },
  },
  watch: {
    "filterForm.crop"(newValue) {
      if (newValue != 0) {
        this.filterForm.workType = "";
        this.workTypeData = [];
        this.getCropWork2({ cropId2: newValue });
      }
    },
  },
  mounted() {
    let { $businessAccountId } = this.$route.query;
    this.masterId = $businessAccountId;
    this.getOrderSettleList();
    this.getAllCropList();
    this.getCropWork2();
  },
  methods: {
    /**
     * @descripttion: 获取种植作物下拉框数据
     * @Author: juanjuanhui
     * @Date: 2021-12-19 14:12:00
     */
    getAllCropList() {
      this.$http.common.getAllCropList().then((res) => {
        this.cropData = res.data;
      });
    },
    /**
     * @descripttion: 获取作业类型二级数据
     * @Author: juanjuanhui
     * @Date: 2021-12-19 14:18:11
     */
    getCropWork2(params) {
      this.$http.common.getCropWork2(params).then((res) => {
        this.workTypeData = res.data;
      });
    },
    /**
     * @descripttion: 查询机具
     * @Author: juanjuanhui
     * @Date: 2021-11-30 10:33:18
     */
    handleFilterPro() {
      this.pagination.currentPage = 1;
      this.getOrderSettleList();
    },
    /**
     * @descripttion: 重置筛选条件
     * @Author: juanjuanhui
     * @Date: 2021-11-30 10:34:18
     * @param {String} formName 表单ref名称
     */
    handleResetFilter(formName) {
      this.$refs[formName].resetFields();
      this.pagination.currentPage = 1;
      this.getOrderSettleList();
    },
    /**
     * @descripttion: 获取查询参数
     * @Author: juanjuanhui
     * @Date: 2021-11-30 10:35:18
     */
    getAllFilters() {
      this.allFilters = { ...this.filterForm };
      if (this.allFilters.orderType == 0) {
        delete this.allFilters.orderType;
      }
      if (this.allFilters.crop == 0) {
        delete this.allFilters.crop;
      }
      if (this.allFilters.workType == 0) {
        delete this.allFilters.workType;
      }
      if (this.allFilters.statusFlag == 0) {
        delete this.allFilters.statusFlag;
      }
    },
    /**
     * @descripttion: 获取订单列表
     * @Author: juanjuanhui
     * @Date: 2021-11-29 10:18:08
     * @param {*}
     */
    getOrderSettleList() {
      this.getAllFilters();
      let { currentPage, pageSize } = this.pagination;
      let params = { currentPage, pageSize, masterId: this.masterId };
      Object.assign(params, params, this.allFilters);
      this.$http.village.getOrderSettleList(params).then((res) => {
        let { recordTotal, content: orders } = res.data;
        this.pagination.recordTotal = recordTotal;
        this.orders = orders;
      });
    },
    /**
     * @descripttion: 切换分页
     * @Author: juanjuanhui
     * @Date: 2021-11-29 10:24:09
     * @param {Number} val 当前页码
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getOrderSettleList();
    },
    /**
     * @descripttion: 查看详情
     * @Author: juanjuanhui
     * @Date: 2021-11-29 10:04:18
     * @param {*} params
     */
    handleLookDetail(params) {
      this.$router.push({
        path: "/village/trustee/order-settle/detail",
        query: { id: params.id },
      });
    },
  },
};
